import { atom } from "nanostores";

import { useStore } from "@nanostores/react";
import { type ManageableLimitedPartnersResponse } from "@vega-api/generated/types/manageableLimitedPartnersResponse";
import { isEmployeeOrgStore } from "@vega-core/stores/isEmployee.store";

export const $organizationId = atom<string | undefined>(undefined);
export const $organization = atom<
  ManageableLimitedPartnersResponse | undefined
>();

export const $organizationList = atom<ManageableLimitedPartnersResponse[]>([]);

export const organisationActions = {
  setOrganisation: (org: ManageableLimitedPartnersResponse) => {
    $organization.set(org);
    $organizationId.set(org.id);
    localStorage.setItem("$organizationId", org.id);
    isEmployeeOrgStore.setIsEmployeeOrg(org.status === "EMPLOYEE");
  },
  setOrganisationId: (id: string) => {
    $organizationId.set(id);
    localStorage.setItem("$organizationId", id);
  },
  setOrganisationList: (list: ManageableLimitedPartnersResponse[]) => {
    $organizationList.set(list);
    localStorage.setItem("$organizationList", JSON.stringify(list));
  },
  clean: () => {
    $organization.set(undefined);
    $organizationId.set(undefined);
    localStorage.removeItem("$organizationId");
  },
};

export const useIsEmployeeOrganisation = () => {
  const org = useStore($organization);

  return org?.status === "EMPLOYEE";
};
